// extracted by mini-css-extract-plugin
module.exports = {"DatePosted":"DatePosted_DatePosted__KmUU3"};